import { cn } from "@foreday/ui/lib/utils";
import type * as React from "react";
import { useEffect, useRef } from "react";

/**
 * A screen's h1, focused on mount so a screen reader lands on the answer rather than the body;
 * `tabIndex={-1}` keeps it out of the tab order. Screens that focus a field pass `takeFocus={false}`.
 */
export function ScreenHeading({
  takeFocus = true,
  className,
  children,
}: {
  readonly takeFocus?: boolean;
  readonly className?: string;
  readonly children: React.ReactNode;
}) {
  const heading = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (takeFocus) heading.current?.focus();
  }, [takeFocus]);

  return (
    <h1 ref={heading} tabIndex={-1} className={cn("outline-none", className)}>
      {children}
    </h1>
  );
}
